import * as React from 'react';
import svgSrc from 'assets/product-hunt.svg';

export const ProductHunt = props => (
  <figure {...props}>
    <img src={svgSrc} alt="Product hunt" />
  </figure>
);
